<script >
import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import EditIcon from "../../icons/EditIcon.vue";
import Switcher from "../../small_components/Switcher.vue";
import AsideDashboard from "../../small_components/AsideDashboard.vue";
import HeaderBlock from "../../parts/HeaderBlock.vue";
import NotifierBlock from "../../parts/NotifierBlock.vue";
import {axiosBelts, axiosBenefits, axiosCommittees, axiosUsers} from "../../../helpers/axios_requests";
import calendar_mixin from "../../../mixins/calendar_mixin";
import routes_mixin from "../../../mixins/routes_mixin";
import InfoBlock from "../../small_components/InfoBlock.vue";
import ChevronLeftIcon from "../../icons/ChevronLeftIcon.vue";
import Loader from "../../small_components/Loader.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import DefaultTitle from "../../small_components/DefaultTitle.vue";
import BadgeBlock from "../../slots/BadgeBlock.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import {ROUTES_NAMES} from "../../../router";
import {mapActions} from "vuex";

export default {
  mixins: [calendar_mixin, routes_mixin],

  name: 'BenefitLayout',
  components: {
    DefaultButton,
    BadgeBlock, DefaultTitle,
    DefaultInput,
    Loader, ChevronLeftIcon, InfoBlock,
    NotifierBlock,
    HeaderBlock,
    AsideDashboard,
    Switcher,
    EditIcon,
    RouterLinkTo,
    SearchInput,
    DefaultBox,
    TablesSlot,

  },

  computed: {
  },
  beforeMount() {
  },

  data() {
    return {
      getUserRoleIsAdmin: true,
      loading: true,
      belt: [],
      benefits: []
    }
  },

  created() {
    this.loading = false;
    this.fetchBelts(this.$route.params.id)
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    searchFetchList() {
      return true;
    },

    fillData(data) {
      this.belt = data || [];
      this.benefits = data.benefits
    },

    fetchBelts(id) {
      this.loading = true
      axiosBelts.package(id)
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },

    createUpdate() {
      axiosBelts.createUpdatePackage(this.belt).then((r) => {
        if (r.data.errors) {
          let message = FORMAT_ERROR_MESSAGE(r.data.errors)
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
          return;
        }
        this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
      }).catch((r) => {
        console.log(r)
      })
    }
  }
}
</script>

<template>
  <div class="user-layout">
    <badge-block>
      <default-title h_tag="h3">
        {{$t('belts.belt_info')}}
      </default-title>
      <default-box class="position-relative"
                :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{$t('belts.belt')}} {{ belt.title }}</h5>
              <div class="card-body">
                <form class="row mt-20"
                      @submit.prevent="createUpdate">
                  <div class="col-md-12 col-12 mb-10">
                    <default-input
                        :label="$t('tables.title')"
                        required
                        v-model="belt.title"
                    />
                  </div>
                  <div class="col-md-12 col-12 mb-10">
                    <default-input
                        :label="$t('belts.description')"
                        required
                        v-model="belt.description"
                    />
                  </div>
                  <div class="text-end mt-20 sticky-bottom">
                    <default-button
                        button_large
                        type="submit">
                      {{ $t('inputs.save') }}
                    </default-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12" >
            <div class="card" v-if="benefits.length > 0">
              <h5 class="card-header">{{ $t('belts.benefits_table') }}</h5>
              <div class="card-body">
                <div class="table-responsive ">
                  <table class="table">
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">{{ $t('tables.title') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(benefit, key) in benefits" :key="key">
                      <th scope="row"><span>{{ benefit.id }}</span></th>
                      <td>
                        <router-link-to
                            class="d-inline-block px-10 py-10"
                            :route_params="{id: benefit.id}"
                            :route_name="route_names.belt_benefit">
                          <edit-icon/>
                          {{ benefit.title }}
                        </router-link-to>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="card" v-else>
              <h5 class="card-header">{{ $t('belts.no_benefits') }} </h5>
              <div class="card-body">
              </div>
            </div>
          </div>
        </div>
      </default-box>
    </badge-block>
  </div>


</template>

<style scoped>

</style>